import { styled } from 'styled-components';
import { IconEdit } from '@tabler/icons-react';

export const StyledEditIcon = styled(IconEdit)`
    height: 20px;
    width: 20px;
`;
